import React, { useState, useEffect } from 'react';
import SplashScreen from './components/SplashScreen';
import TakeawayGym from './components/TakeawayGym';
import Chatbot from './components/Chatbot';
import firebaseUserService from './components/FirebaseUserService';

// Initialize Firebase User Service when app starts
firebaseUserService.initialize();

// --- Main App Component ---
export default function App() {
    const [currentView, setCurrentView] = useState('splash');

    useEffect(() => {
        const timer = setTimeout(() => {
            // Changed from 'chatbot' to 'gym' to go directly to TakeawayGym
            setCurrentView('gym');
        }, 5000);
        return () => clearTimeout(timer);
    }, []);

    const renderView = () => {
        switch (currentView) {
            case 'splash':
                return <SplashScreen />;
            case 'chatbot':
                // Keep this case in case you want to access the questionnaire later
                return <Chatbot onSessionComplete={() => setCurrentView('gym')} />;
            case 'gym':
            default:
                // Now defaults to TakeawayGym instead of Chatbot
                return <TakeawayGym />;
        }
    };

    return (
        <div style={styles.appContainer}>
            {renderView()}
        </div>
    );
}

// --- Styles ---
const styles = {
    appContainer: {
        fontFamily: "'Helvetica Neue', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', sans-serif",
        backgroundColor: '#f0f2f5',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#333',
    },
};